var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 32,
    viewBox: "0 0 111 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.897 32H4.33328C2.07789 32 0.230713 30.199 0.230713 28V4C0.230713 1.801 2.07789 1.90735e-06 4.33328 1.90735e-06H106.897C109.153 1.90735e-06 111 1.801 111 4V28C111 30.199 109.153 32 106.897 32Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.897 0.641001C108.797 0.641001 110.342 2.148 110.342 4V28C110.342 29.852 108.797 31.359 106.897 31.359H4.33328C2.43379 31.359 0.888149 29.852 0.888149 28V4C0.888149 2.148 2.43379 0.641001 4.33328 0.641001H106.897ZM106.897 1.90735e-06H4.33328C2.07789 1.90735e-06 0.230713 1.801 0.230713 4V28C0.230713 30.199 2.07789 32 4.33328 32H106.897C109.153 32 111 30.199 111 28V4C111 1.801 109.153 1.90735e-06 106.897 1.90735e-06Z",
    fill: "#1C1F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79274 6.03134C8.55172 6.27734 8.41223 6.66034 8.41223 7.15634V24.8483C8.41223 25.3443 8.55172 25.7273 8.79274 25.9733L8.85223 26.0273L19.0204 16.1173V15.8833L8.85223 5.97334L8.79274 6.03134Z",
    fill: "url(#paint0_linear_3376_201966)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.406 19.4238L19.0204 16.1188V15.8848L22.4101 12.5798L22.486 12.6228L26.5004 14.8498C27.646 15.4818 27.646 16.5218 26.5004 17.1578L22.486 19.3808L22.406 19.4238Z",
    fill: "url(#paint1_linear_3376_201966)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4861 19.38L19.0204 16.001L8.79272 25.974C9.17324 26.364 9.79375 26.411 10.4994 26.021L22.4861 19.38Z",
    fill: "url(#paint2_linear_3376_201966)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4861 12.621L10.4994 5.98C9.79375 5.594 9.17324 5.641 8.79272 6.031L19.0204 16L22.4861 12.621Z",
    fill: "url(#paint3_linear_3376_201966)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1374 8.19519C39.1374 8.86319 38.9323 9.39819 38.5282 9.79719C38.0636 10.2702 37.4584 10.5082 36.7169 10.5082C36.0082 10.5082 35.4031 10.2662 34.9066 9.78919C34.4092 9.30519 34.161 8.71119 34.161 8.00019C34.161 7.28919 34.4092 6.69519 34.9066 6.21519C35.4031 5.73419 36.0082 5.49219 36.7169 5.49219C37.0697 5.49219 37.4061 5.56319 37.7272 5.69519C38.0472 5.82819 38.3077 6.00819 38.4964 6.23019L38.0677 6.65219C37.7384 6.27319 37.2902 6.08619 36.7169 6.08619C36.2 6.08619 35.7518 6.26219 35.3713 6.61719C34.9949 6.97319 34.8061 7.43419 34.8061 8.00019C34.8061 8.56619 34.9949 9.03119 35.3713 9.38719C35.7518 9.73819 36.2 9.91819 36.7169 9.91819C37.2656 9.91819 37.7272 9.73819 38.0913 9.38319C38.3313 9.14819 38.4677 8.82419 38.5036 8.41019H36.7169V7.83219H39.1005C39.1292 7.95719 39.1374 8.07819 39.1374 8.19519Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.919 6.19056H40.68V7.71056H42.6985V8.28856H40.68V9.80856H42.919V10.3976H40.0461V5.60156H42.919V6.19056Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5876 10.3976H44.9538V6.19056H43.5804V5.60156H46.962V6.19056H45.5876V10.3976Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 10.3976V5.60156H50.042V10.3976H49.4092Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8471 10.3976H52.2184V6.19056H50.84V5.60156H54.2256V6.19056H52.8471V10.3976Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6276 9.78119C60.1425 10.2662 59.5415 10.5082 58.8245 10.5082C58.1035 10.5082 57.5025 10.2662 57.0174 9.78119C56.5333 9.29719 56.2922 8.70319 56.2922 8.00019C56.2922 7.29719 56.5333 6.70319 57.0174 6.21919C57.5025 5.73419 58.1035 5.49219 58.8245 5.49219C59.5374 5.49219 60.1384 5.73419 60.6235 6.22319C61.1117 6.71119 61.3528 7.30119 61.3528 8.00019C61.3528 8.70319 61.1117 9.29719 60.6276 9.78119ZM57.4861 9.37919C57.8512 9.73819 58.2953 9.91819 58.8245 9.91819C59.3497 9.91819 59.7979 9.73819 60.1589 9.37919C60.523 9.02019 60.7076 8.55919 60.7076 8.00019C60.7076 7.44119 60.523 6.98019 60.1589 6.62119C59.7979 6.26219 59.3497 6.08219 58.8245 6.08219C58.2953 6.08219 57.8512 6.26219 57.4861 6.62119C57.122 6.98019 56.9374 7.44119 56.9374 8.00019C56.9374 8.55919 57.122 9.02019 57.4861 9.37919Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2421 10.3976V5.60156H63.0113L65.4031 9.33156H65.4308L65.4031 8.40956V5.60156H66.0359V10.3976H65.3754L62.8708 6.48356H62.8431L62.8708 7.40956V10.3976H62.2421Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1363 17.4017C54.2091 17.4017 52.6348 18.8317 52.6348 20.8047C52.6348 22.7617 54.2091 24.2067 56.1363 24.2067C58.0676 24.2067 59.642 22.7617 59.642 20.8047C59.642 18.8317 58.0676 17.4017 56.1363 17.4017ZM56.1363 22.8667C55.0789 22.8667 54.1691 22.0157 54.1691 20.8047C54.1691 19.5777 55.0789 18.7417 56.1363 18.7417C57.1938 18.7417 58.1076 19.5777 58.1076 20.8047C58.1076 22.0157 57.1938 22.8667 56.1363 22.8667ZM48.4963 17.4017C46.565 17.4017 44.9948 18.8317 44.9948 20.8047C44.9948 22.7617 46.565 24.2067 48.4963 24.2067C50.4266 24.2067 51.9979 22.7617 51.9979 20.8047C51.9979 18.8317 50.4266 17.4017 48.4963 17.4017ZM48.4963 22.8667C47.4379 22.8667 46.525 22.0157 46.525 20.8047C46.525 19.5777 47.4379 18.7417 48.4963 18.7417C49.5538 18.7417 50.4635 19.5777 50.4635 20.8047C50.4635 22.0157 49.5538 22.8667 48.4963 22.8667ZM39.4051 18.4447V19.8907H42.9466C42.843 20.6987 42.5661 21.2927 42.1415 21.7067C41.6245 22.2067 40.8194 22.7617 39.4051 22.7617C37.2256 22.7617 35.5189 21.0467 35.5189 18.9217C35.5189 16.7967 37.2256 15.0817 39.4051 15.0817C40.5835 15.0817 41.4409 15.5307 42.0738 16.1127L43.1189 15.0937C42.2338 14.2697 41.0563 13.6367 39.4051 13.6367C36.4163 13.6367 33.9045 16.0077 33.9045 18.9217C33.9045 21.8357 36.4163 24.2067 39.4051 24.2067C41.0204 24.2067 42.2338 23.6907 43.1876 22.7227C44.165 21.7697 44.4697 20.4297 44.4697 19.3477C44.4697 19.0117 44.4409 18.7027 44.3897 18.4447H39.4051ZM76.5804 19.5657C76.2922 18.8047 75.403 17.4017 73.5917 17.4017C71.7968 17.4017 70.3025 18.7807 70.3025 20.8047C70.3025 22.7107 71.7814 24.2067 73.764 24.2067C75.3671 24.2067 76.2922 23.2537 76.6727 22.6987L75.483 21.9257C75.0861 22.4917 74.5455 22.8667 73.764 22.8667C72.9876 22.8667 72.4307 22.5197 72.0738 21.8357L76.7414 19.9527L76.5804 19.5657ZM71.8214 20.6987C71.7815 19.3867 72.8666 18.7147 73.644 18.7147C74.2532 18.7147 74.7702 19.0117 74.9425 19.4367L71.8214 20.6987ZM68.0276 23.9997H69.562V13.9997H68.0276V23.9997ZM65.5148 18.1597H65.4635C65.1189 17.7617 64.4615 17.4017 63.6286 17.4017C61.8809 17.4017 60.283 18.8977 60.283 20.8157C60.283 22.7227 61.8809 24.2067 63.6286 24.2067C64.4615 24.2067 65.1189 23.8437 65.4635 23.4337H65.5148V23.9217C65.5148 25.2227 64.802 25.9217 63.6522 25.9217C62.7148 25.9217 62.1332 25.2617 61.8932 24.7067L60.5589 25.2497C60.9435 26.1517 61.962 27.2617 63.6522 27.2617C65.4512 27.2617 66.9691 26.2297 66.9691 23.7187V17.6087H65.5148V18.1597ZM63.7599 22.8667C62.7025 22.8667 61.8173 22.0037 61.8173 20.8157C61.8173 19.6167 62.7025 18.7417 63.7599 18.7417C64.802 18.7417 65.6235 19.6167 65.6235 20.8157C65.6235 22.0037 64.802 22.8667 63.7599 22.8667ZM83.764 13.9997H80.0943V23.9997H81.6245V20.2107H83.764C85.4635 20.2107 87.1302 19.0117 87.1302 17.1047C87.1302 15.1987 85.4594 13.9997 83.764 13.9997ZM83.804 18.8197H81.6245V15.3907H83.804C84.9466 15.3907 85.5989 16.3157 85.5989 17.1047C85.5989 17.8787 84.9466 18.8197 83.804 18.8197ZM93.2635 17.3827C92.1579 17.3827 91.0081 17.8587 90.5353 18.9137L91.8932 19.4687C92.1855 18.9137 92.723 18.7337 93.2912 18.7337C94.085 18.7337 94.8902 19.1987 94.9025 20.0197V20.1247C94.6255 19.9687 94.0327 19.7377 93.3035 19.7377C91.8409 19.7377 90.3507 20.5227 90.3507 21.9877C90.3507 23.3277 91.5486 24.1907 92.8953 24.1907C93.925 24.1907 94.4932 23.7377 94.8502 23.2107H94.9025V23.9837H96.3804V20.1477C96.3804 18.3747 95.0225 17.3827 93.2635 17.3827ZM93.0789 22.8627C92.5784 22.8627 91.8809 22.6207 91.8809 22.0157C91.8809 21.2417 92.7507 20.9447 93.5035 20.9447C94.1773 20.9447 94.4932 21.0897 94.9025 21.2807C94.7825 22.2067 93.965 22.8627 93.0789 22.8627ZM101.765 17.6017L100.006 21.9367H99.9538L98.1353 17.6017H96.485L99.2173 23.6597L97.6584 27.0307H99.2573L103.468 17.6017H101.765ZM87.9712 23.9997H89.5055V13.9997H87.9712V23.9997Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3376_201966",
    x1: 18.1176,
    y1: 25.0326,
    x2: 4.696,
    y2: 11.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3376_201966",
    x1: 27.9922,
    y1: 16.0007,
    x2: 8.13834,
    y2: 16.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3376_201966",
    x1: 20.6015,
    y1: 14.1641,
    x2: 2.40074,
    y2: -4.50341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3376_201966",
    x1: 6.2182,
    y1: 31.859,
    x2: 14.3457,
    y2: 23.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBlack);
export default __webpack_public_path__ + "static/media/GooglePlayBlack.c899f47f5f7dd294fb2447110c67d36f.svg";
export { ForwardRef as ReactComponent };